function findApprovalLevelInList(approvalLevels, approvalLevel, perItemCustomCheck = null) {
  if (!approvalLevels?.length || !approvalLevel) return null;

  return approvalLevels.find(
    (al) =>
      al.approvalLevelId === approvalLevel.approvalLevelId &&
      (!al.fundingSourceId || al.fundingSourceId === approvalLevel.fundingSourceId) &&
      (!perItemCustomCheck || perItemCustomCheck(al))
  );
}

module.exports = {
  findApprovalLevelInList,
};
